<template>
    <Modal :color="ConfigModalsColor" @close="CloseModal" max_width="600" title="Help Us Improve — Write a review!" :visible="true">
        <v-card-text>
            <v-card elevation="0" v-for="review in reviews">
                <v-card-text class="d-flex align-center pa-1">
                    <div>
                        <v-img width="50" height="50" :src="ProductImage(Product(review.product_id))" :lazy-src="ProductImage(Product(review.product_id))"/>
                    </div>
                    <div>
                        <h4 class="font-weight-light ma-0">{{Product(review.product_id).name}}</h4>
                        <small class="d-block">{{Product(review.product_id).model_number}}</small>
                    </div>
                </v-card-text>
            </v-card>

            <v-card elevation="0" class="mt-5 border pb-0">
                <v-card-text>
                    <p class="mb-5">Share Your Thoughts on the Printers You Quoted and the experience using our site</p>

                    <small>Your rating of this transaction: *</small>
                    <div class="mt-1">
                        <v-icon @click="rating=1" size="xx-large" :color="rating>0 ? '#ff9b00':'grey'">mdi-star</v-icon>
                        <v-icon @click="rating=2" size="xx-large" :color="rating>1 ? '#ff9b00':'grey'">mdi-star</v-icon>
                        <v-icon @click="rating=3" size="xx-large" :color="rating>2 ? '#ff9b00':'grey'">mdi-star</v-icon>
                        <v-icon @click="rating=4" size="xx-large" :color="rating>3 ? '#ff9b00':'grey'">mdi-star</v-icon>
                        <v-icon @click="rating=5" size="xx-large" :color="rating>4 ? '#ff9b00':'grey'">mdi-star</v-icon>
                    </div>

                    <small class="d-block mt-5">Your Review (optional)</small>
                    <v-textarea hide-details class="review-comment-box" rows="2" variant="outlined" v-model="comment"/>
                </v-card-text>
            </v-card>
        </v-card-text>

        <template #footer>
            <div>
                <v-checkbox-btn :disabled="loading" @update:modelValue="SetAuthor" v-model="author" label="Review anonymously"/>
            </div>
            <v-spacer/>
            <v-btn :loading="loading" @click="SubmitReview" variant="tonal" prepend-icon="mdi-pencil" :color="ConfigElementsColor">Submit Review</v-btn>
        </template>
    </Modal>
</template>

<script>
import moment from "moment";
import Server from "@/plugins/Server";
import {mapActions, mapState} from "pinia";
import {useGlobalsStore} from "@/stores/globals";
import Modal from "@/components/misc/Modal.vue";
import {CommonMixins} from "@/mixins/CommonMixins";

export default {
    components: {Modal},
    data: () => ({
        reviews: [],
        comment: "",
        rating:  5,
        author: "",
        loading: false,
    }),
    mixins: [CommonMixins],
    computed: {
        ...mapState(useGlobalsStore, ['cart_items','products','form']),
        ReviewerName() {
            const name = this.form.lead.firstname;
            if (!name || name.length < 1) {
                return 'Anonymous';
            }
            return name;
        }
    },
    methods: {
        ...mapActions(useGlobalsStore, ['SetAnyState','SetError','SetSuccess']),
        RecalcReviews() {
            this.reviews = [];
            this.cart_items.forEach(cart => {
                this.reviews.push({
                    product_id: cart.product.id,
                    rating:  5,
                    comment: "",
                    author:  "",
                    source: window.location.hostname,
                    created_at: moment().format('MM/DD/YYYY hh:mm a'),
                    updated_at: moment().format('MM/DD/YYYY hh:mm a'),
                });
            });
        },
        Product(id) {
            const product = this.products.find(p => p.id == id);
            if (product) {
                return product;
            } else {
                return {};
            }
        },
        SetAuthor(is_checked) {
            if (is_checked) {
                this.reviews.forEach((review, index) => {
                    this.reviews[index].author = "Anonymous";
                });
            } else {
                this.reviews.forEach((review, index) => {
                    this.reviews[index].author = this.ReviewerName;
                });
            }
        },
        CloseModal() {
            this.SetAnyState({
                target: 'review_modal',
                value: false,
            });
        },
        SubmitReview() {
            this.loading = true;
            const form = new FormData;
            form.append('reviews',JSON.stringify(this.reviews));
            Server.post('/reviews/store',form).then(res => {
                console.log(res.data);
                this.SetSuccess("Thank you for your feedback!");
                this.CloseModal();
                this.reviews = [];
            }).catch(err => {
                console.log(err);
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    mounted() {
        this.RecalcReviews();
    },
    watch: {
        cart_items() {
            this.RecalcReviews();
        },
        comment(newVal) {
            this.reviews.forEach((review, index) => {
                this.reviews[index].comment = newVal;
            });
        },
        rating(newVal) {
            this.reviews.forEach((review, index) => {
                this.reviews[index].rating = newVal;
            });
        }
    }
}
</script>
